import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c874e65e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { computed, PropType } from 'vue'
import { PPTImageElement } from '@/types/slides'
import useElementShadow from '@/views/components/element/hooks/useElementShadow'
import useElementFlip from '@/views/components/element/hooks/useElementFlip'
import useClipImage from './useClipImage'
import useFilter from './useFilter'

import ImageOutline from './ImageOutline/index.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseImageElement',
  props: {
  elementInfo: {
    type: Object as PropType<PPTImageElement>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const shadow = computed(() => props.elementInfo.shadow)
const { shadowStyle } = useElementShadow(shadow)

const flipH = computed(() => props.elementInfo.flipH)
const flipV = computed(() => props.elementInfo.flipV)
const { flipStyle } = useElementFlip(flipH, flipV)

const clip = computed(() => props.elementInfo.clip)
const { clipShape, imgPosition } = useClipImage(clip)

const filters = computed(() => props.elementInfo.filters)
const { filter } = useFilter(filters)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "base-element-image",
    style: _normalizeStyle({
      top: __props.elementInfo.top + 'px',
      left: __props.elementInfo.left + 'px',
      width: __props.elementInfo.width + 'px',
      height: __props.elementInfo.height + 'px',
    })
  }, [
    _createElementVNode("div", {
      class: "rotate-wrapper",
      style: _normalizeStyle({ transform: `rotate(${__props.elementInfo.rotate}deg)` })
    }, [
      _createElementVNode("div", {
        class: "element-content",
        style: _normalizeStyle({
          filter: _unref(shadowStyle) ? `drop-shadow(${_unref(shadowStyle)})` : '',
          transform: _unref(flipStyle),
        })
      }, [
        _createVNode(ImageOutline, { elementInfo: __props.elementInfo }, null, 8, ["elementInfo"]),
        _createElementVNode("div", {
          class: "image-content",
          style: _normalizeStyle({ clipPath: _unref(clipShape).style })
        }, [
          _createElementVNode("img", {
            src: __props.elementInfo.src,
            draggable: false,
            style: _normalizeStyle({
              top: _unref(imgPosition).top,
              left: _unref(imgPosition).left,
              width: _unref(imgPosition).width,
              height: _unref(imgPosition).height,
              filter: _unref(filter),
            }),
            alt: ""
          }, null, 12, _hoisted_1),
          (__props.elementInfo.colorMask)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "color-mask",
                style: _normalizeStyle({
              backgroundColor: __props.elementInfo.colorMask.color,
              opacity: __props.elementInfo.colorMask.opacity,
            })
              }, null, 4))
            : _createCommentVNode("", true)
        ], 4)
      ], 4)
    ], 4)
  ], 4))
}
}

})